import { validataCoachFromDatabase } from 'services/coachProfile.service';
// import { fromJS } from 'immutable';
import {
    GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTRATION,
} from 'components/CoachRegistration';

import {
    GET_COACH_FROM_DATABASE_SUCCESSFUL,
    GET_COACH_FROM_DATABASE_REQUESTED,
    GET_COACH_FROM_DATABASE_FAILED,
} from './actionTypes';

export default function getCoachFromDatabase(payload) { // eslint-disable-line
  return (dispatch) => {
    dispatch({
      type: GET_COACH_FROM_DATABASE_REQUESTED,
    });
    validataCoachFromDatabase(payload)
            .then((data) => {
              if (data) {
                dispatch({
                  type: GET_COACH_FROM_DATABASE_SUCCESSFUL,
                  validCoach: data,
                });
                dispatch({
                  type: GET_COACH_FROM_DATABASE_SUCCESSFUL_REGISTRATION,
                  validCoach: data,
                });
              }
            })
            .catch((err) => {
              dispatch({
                type: GET_COACH_FROM_DATABASE_FAILED,
                error: err,
              });
            });
  };
}



// WEBPACK FOOTER //
// ./src/containers/VerifyCoach/actions.js